var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoader = function SvgLoader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: "0s",
    calcMode: "spline",
    dur: "1.8s",
    keySplines: "0.165, 0.84, 0.44, 1",
    keyTimes: "0; 1",
    repeatCount: "indefinite",
    values: "1; 20"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    begin: "0s",
    calcMode: "spline",
    dur: "1.8s",
    keySplines: "0.3, 0.61, 0.355, 1",
    keyTimes: "0; 1",
    repeatCount: "indefinite",
    values: "1; 0"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: "-0.9s",
    calcMode: "spline",
    dur: "1.8s",
    keySplines: "0.165, 0.84, 0.44, 1",
    keyTimes: "0; 1",
    repeatCount: "indefinite",
    values: "1; 20"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    begin: "-0.9s",
    calcMode: "spline",
    dur: "1.8s",
    keySplines: "0.3, 0.61, 0.355, 1",
    keyTimes: "0; 1",
    repeatCount: "indefinite",
    values: "1; 0"
  })))));
};
export default SvgLoader;